import dynamic from 'next/dynamic';
import React from 'react';
import { getAllProjects, getAllTags } from '../lib/projects';
import Seo from '../components/Seo';
import CriticalAbout from '../components/CriticalAbout';

const App = dynamic(() => import('../components/App'), { ssr: false });

export async function getStaticProps() {
    try {
        const projects = getAllProjects();
        const allTags = getAllTags();
        return {
            props: {
                projects,
                allTags,
            },
        };
    } catch (error) {
        console.error('Error loading projects:', error);
        return {
            props: {
                projects: [],
                allTags: [],
            },
        };
    }
}

export default function Home({ projects = [], allTags = [] }) {
    return (
        <>
            <Seo projects={projects} />
            <App projects={projects} allTags={allTags} />
            <CriticalAbout />
        </>
    );
}
